import { render, staticRenderFns } from "./ToggleOcurrence.vue?vue&type=template&id=a80ddeaa&scoped=true"
import script from "./ToggleOcurrence.vue?vue&type=script&lang=js"
export * from "./ToggleOcurrence.vue?vue&type=script&lang=js"
import style0 from "./ToggleOcurrence.vue?vue&type=style&index=0&id=a80ddeaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ddeaa",
  null
  
)

export default component.exports